import api from "./axios/api";

const devConfig = {
  // URL_SERVICE: "http://192.168.21.117:8083/mx_dspt_service",
  // URL_SERVICE: "https://mx-bs-dspt-http-sy.mxnavi.com/mx_dspt_service",
  URL_SERVICE: "https://mx-bs-dspt-http-ca.mxnavi.com/mx_dspt_service",
  // URL_SERVICE: "https://mx-bs-dspt-http-ln.mxnavi.com/mx_dspt_service",
  // URL_SERVICE: "https://mx-bs-dspt-http-pre.mxnavi.com/mx_dspt_service",
  WORK: {
    oemId: "307002", //040501
    appId: "30700201", //040501
    domtitle: "鹿驾网"
  }
};

const getJson = () =>
  api
    .get({
      service: "",
      url: "/static/mx-common/apollo.json",
      urlItem: "",
      transURL: false
    })
    .then(res => res);

const getApolloConfig = params =>
  api
    .post({
      service: "",
      data: params,
      url: `${document.location.protocol}//${params.MxUrlService}/mx_dspt_service/callback/apolloCallback`,
      urlItem: "",
      transURL: false,
      headers: {
        "Content-Type": "application/json; charset=UTF-8"
      }
    })
    .then(resp => {
      try {
        resp.content = resp.content.replace(/\s*/g, "");
        return eval(`(${resp.content})`);
      } catch (error) {
        return {};
      }
    });
const prodConfig = async () => {
  let config = await getJson();

  let apolloConfig = await getApolloConfig(config);

  return apolloConfig;
};

const getConfig = async env => {
  if (env === "development" || env === "mock") {
    return devConfig;
  }
  // let config = prodConfig();
  // devConfig.URL_SERVICE = `${config.MxUrlService}/mx_dspt_service`
  return prodConfig();
};

export default {
  getConfig
};
